export enum ActionType {
  AccessMyPolicy = "accessMyPolicyId",
  MakePayment = "makePaymentId",
  ReportClaim = "reportClaimId",
  AddDocuments = "addDocsId",
  ManageAutopay = "managetAutopayId",
  ExploreFAQs = "exploreFAQsId",
  SeeLastInvoice = "seeLastInvoiceId",
  ViewTransactions = "viewTransactionsId",
  DiscoverRewards = "discoverRewardsId",
  GetIdCards = "getIdCardsId",
  AskQuestion = "askQuestionId",
  BillingRequest = "billingRequestId",
  FindRoadsideAid = "findRoadsideAidId"
}